<template>
  <el-popover
    placement="bottom"
    width="330"
    trigger="hover"
    :popper-class="'notice-center'"
    style="margin-left: 16px"
    @after-leave="readMessage"
  >
    <div class="notice-header">
      {{ $t('system::common::dialog::message_manage') }}
    </div>
    <div class="notice-list">
      <div class="item" v-for="item in messageList" :key="item.id" @click="handle(item, 'message')">
        <div class="icon">
          <i class="iconfont iconxitongxiaoxi1"></i>
        </div>
        <div class="container" :class="{ disable: !!item.status }">
          <div class="title">
            <div class="title-name">{{ item.header }}</div>
            <div class="title-time">{{ item.pushTime.slice(0, -3) }}</div>
          </div>
          <div class="content">
            {{ item.message }}
          </div>
        </div>
      </div>
      <div class="item" v-for="item in noticeList" :key="item.id" @click="handle(item, 'notice')">
        <div class="icon" style="background: #ffeedf">
          <i class="iconfont icongonggao1"></i>
        </div>
        <div class="container" :class="{ disable: !!item.status }">
          <div class="title">
            <div class="title-name">{{ item.title }}</div>
            <div class="title-time">{{ item.pubtime.slice(0, -3) }}</div>
          </div>
          <div class="content">
            {{ item.content }}
          </div>
        </div>
      </div>
      <template v-if="messageList && noticeList">
        <default-data v-show="!(messageList.length + noticeList.length)" style="height: 200px"></default-data>
      </template>
    </div>
    <div class="notice-footer" @click="$router.push('/message-center')">
      {{ $t('system::common::dialog::message_more') }}
    </div>
    <el-badge :value="count" is-dot :hidden="!count" :max="99" slot="reference">
      <!-- <i class="iconfont iconNews"></i> -->
      <div class="header-iconMessage"></div>
      <showDetail v-model="isShowDetail" :message="message" @closed="close"></showDetail>
    </el-badge>
  </el-popover>
</template>

<script>
import showDetail from '@/views/message-center/components/showDetail.vue'
import { setMessageRead, setNoticeRead } from '@/server/message'
import { routerTo } from '@/utils/message'
export default {
  components: { showDetail },
  data() {
    return {
      isShowDetail: false,
      message: {},
    }
  },
  computed: {
    noticeList() {
      return this.$store.state.message.noticeList
    },
    messageList() {
      return this.$store.state.message.messageList
    },
    count() {
      return this.$store.getters.getCount
    },
    newNotice() {
      return this.$store.state.message.newNotice
    },
  },
  watch: {
    newNotice(val) {
      if (val.id) {
        this.isShowDetail = true
        this.message = { ...val }
        this.setNoticeRead([val])
      }
    },
  },
  methods: {
    handle(item, type) {
      if (type === 'message') {
        routerTo.call(this, item)
      } else if (type === 'notice') {
        this.isShowDetail = true
        this.message = item
        this.setNoticeRead([item])
      }
    },
    readMessage() {
      if (this.messageList.length) {
        this.setMessageRead(this.messageList)
      }
    },
    async setMessageRead(list) {
      const ids = list.filter(el => !el.status).map(el => el.id)
      if (ids.length) {
        await setMessageRead(ids)
        this.$store.dispatch('getMessageList')
      }
    },
    async setNoticeRead(list) {
      const ids = list.map(el => el.id)
      const { data } = await setNoticeRead({ ids })
      if (data.code === this.$code) {
        this.$store.dispatch('getNoticeList')
      }
    },
    close() {
      this.message = {}
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-badge__content.is-fixed {
  top: 3px;
  right: 10px;
}
/deep/ .el-badge__content.is-dot {
  height: 6px;
  width: 6px;
}
/deep/ .el-badge__content {
  border: 1px solid #01123a;
  background-color: #ff5250;
}
.notice-header {
  padding: 16px 24px;
  color: #010517;
  border-bottom: 1px solid #edeff2;
}
.notice-footer {
  padding: 16px 24px;
  text-align: center;
  color: #010517;
  border-top: 1px solid #edeff2;
  cursor: pointer;
}
.notice-list {
  display: flex;
  flex-direction: column;
}
.item {
  display: flex;
  padding: 12px 24px;
  width: 100%;
  cursor: pointer;
  .icon {
    width: 30px;
    height: 30px;
    background: #eaf2ff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .iconxitongxiaoxi1 {
    color: #3e7eff;
  }
  .icongonggao1 {
    color: #ff8c2a;
  }
  .container {
    width: 236px;
    margin-left: 16px;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }
  .title-name {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
    color: #010517;
  }
  .title-time {
    font-size: 10px;
    color: #999;
  }
  .content {
    color: #999;
    font-size: 12px;
    margin-top: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; //行数
    -webkit-box-orient: vertical;
  }
}
.item + .item {
  border-top: 1px solid #edeff2;
}
.iconNews {
  font-size: 26px;
  color: #fff;
}
.header-iconMessage {
  cursor: pointer;
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-image: url('../../assets/images/header/message.png');
}
.disable {
  color: #bbb !important;
  .title-name {
    color: #bbb !important;
  }
  .title-time {
    color: #bbb !important;
  }
  .content {
    color: #bbb !important;
  }
}
</style>
<style>
.notice-center {
  padding: 0px !important;
  outline: none;
}
</style>
